import React, { FC, useEffect, useRef } from "react";
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";
import { addHours, addMinutes, addSeconds } from "date-fns";
// utils
import { generateRandomId } from "utils/GenerateRandomId";

interface MongoChartProps {
  endDate: string;
  startDate: string;
  dashboardId: string;
  heightChart?: string;
  refreshChart: boolean;
}

export const MongoChart: FC<MongoChartProps> = (props) => {
  const { dashboardId, endDate, startDate, heightChart, refreshChart } = props;

  const chartContainerRef = useRef(null);

  useEffect(() => {
    if (!chartContainerRef.current) return;

    const sdk = new ChartsEmbedSDK({
      baseUrl: "https://charts.mongodb.com/charts-prd---viveo---inovacao-ggrkl"
    });

    const daysAgo = new Date(startDate);
    const today = new Date(endDate);

    const chart = sdk.createDashboard({
      dashboardId: dashboardId,
      widthMode: 'scale',
      heightMode: 'scale',
      showTitleAndDesc: true,
      autoRefresh: true,
      theme: 'light',
      maxDataAge: 3600,
      filter: {
        createdDate: {
          $gte: addHours(daysAgo, 3),
          $lte: addHours(addMinutes(addSeconds(today, 59), 59), 26),
        },
      },
    });

    chart.render(chartContainerRef.current);
  }, [refreshChart]);

  return <div
    key={generateRandomId("Chart")}
    ref={chartContainerRef}
    style={{
      width: "100%",
      height: heightChart ?? "450px",
      boxShadow: "0 2px 10px 0 rgba(70, 76, 79, 0.2)"
    }}
  />;
};
